import { createFileRoute, Outlet } from "@tanstack/react-router";

import { requireSection } from "@/shared/auth/access";

/** The administration section: what it holds, staff and their roles. One guard for all. */
export const Route = createFileRoute("/_app/settings")({
  beforeLoad: ({ context }) => {
    requireSection(context.role, "settings");
  },
  component: Outlet,
});
